import { render } from "./Formato1970.vue?vue&type=template&id=08ac5df8&scoped=true"
import script from "./Formato1970.vue?vue&type=script&lang=js"
export * from "./Formato1970.vue?vue&type=script&lang=js"

import "./Formato1970.vue?vue&type=style&index=0&id=08ac5df8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ac5df8"]])

export default __exports__